export const BUSINESS = {
  value: 'business',
  label: 'Business'
}
export const INDIVIDUAL = {
  value: 'individual',
  label: 'Individual'
}
